// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__2pSnE","others":"styles_others__8htYb","current":"styles_current__1vwGt","prev":"styles_prev__RU04G","next":"styles_next__2cE2P"};